import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

// Styles
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import "./style/css/feather.css";
import "./style/css/line-awesome.min.css";
import "./style/icons/tabler-icons/webfont/tabler-icons.css";
import "./style/scss/main.scss";
import "./customStyle.scss";
import "./style/icons/fontawesome/css/fontawesome.min.css";
import "./style/icons/fontawesome/css/all.min.css";
import "./style/fonts/feather/css/iconfont.css";
import "./style/global.css";

import AllRoutes from "./Router/router";
import store from "./core/redux/store";
import { base_path } from "./environment";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { setupAxiosInterceptors } from "./core/redux/tokenUtils";
import {
  requestForToken,
  messaging,
  registerFirebaseServiceWorker,
} from "./firebase-config"; // ✅ Include the custom reg func
import { onMessage } from "firebase/messaging";
import { toast } from "react-hot-toast";
import useSound from "use-sound";
import notificationSound from "../src/sounds/notification.mp3";

// Axios JWT setup
setupAxiosInterceptors();

const AppWithNotifications = () => {
  const [play] = useSound(notificationSound);

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      // console.log("🔔 Foreground Push Received:", payload);
      const notification = payload.notification;
      if (notification) {
        toast.success(`${notification.title} — ${notification.body}`);
        play();
      }
    });
    return () => unsubscribe();
  }, [play]);

  return (
    <BrowserRouter basename={base_path}>
      <AllRoutes />
    </BrowserRouter>
  );
};

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <AppWithNotifications />
      </Provider>
    </React.StrictMode>
  );
} else {
  console.error("❌ Element with id 'root' not found.");
}

// ✅ SINGLE Service Worker Registration Block
serviceWorkerRegistration.register({
  onSuccess: async (registration) => {
    // console.log("✅ Service Worker Registered Successfully.");
    await registerFirebaseServiceWorker(); // This handles .useServiceWorker internally
  },
});
